<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-flag"></i> Tournaments
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Tournament ID</th>
              <th>End Date</th>
              <th>Best Points</th>
              <th>Best Matchs</th>
              <th>Current Points</th>
              <th>Current Matchs</th>
              <th>Rank</th>
              <th>Status</th>
              <th>Reward</th>
              <th>Matchs</th>
            </tr>
          </thead>
          <tbody>
            @for (tournament of tournaments; track tournament.tournamentId; let i = $index) {
              <tr>
                <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                <td>{{ tournament.tournamentId }}</td>
                <td>{{ tournament.tournamentEndDateTimestamp !== 0 ? dateService.getDateFromatted(tournament.tournamentEndDateTimestamp) : '-' }}</td>
                <td>{{ tournament.bestPoints }}</td>
                <td>{{ tournament.bestMatchCount }}</td>
                <td>{{ tournament.currentPoints }}</td>
                <td>{{ tournament.currentMatchCount }}</td>
                <td>{{ tournament.rank !== 0 ? tournament.rank : '-' }}</td>
                <td>
                  @if (tournament.isActive && tournament.tournamentEndDateTimestamp * 1000 > dateService.getTimestampUtc()) {
                    <span class="badge bg-success">Active</span>
                  }
                </td>
                <td>
                  @if (tournament.isRewardGranted) {
                    <span class="badge bg-success">Granted</span>
                  } @else {
                    <span class="badge bg-secondary">Pending</span>
                  }
                </td>
                <td>
                  @if (tournament.matchs.length > 0) {
                    <button class="btn btn-sm btn-primary" (click)="toggleMatchs(tournament.tournamentId)">
                      <i class="fa fa-{{ expandedMatchs.has(tournament.tournamentId) ? 'chevron-up' : 'list' }}"></i>
                      {{ tournament.matchs.length }}
                    </button>
                  } @else {
                    -
                  }
                </td>
              </tr>
              @if (expandedMatchs.has(tournament.tournamentId)) {
                <tr>
                  <td colspan="10" class="p-0">
                    <table class="table table-sm mb-0" style="background-color: #f8f9fa">
                      <thead>
                        <tr>
                          <th class="ps-4">#</th>
                          <th>Match ID</th>
                          <th>Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (match of tournament.matchs; track match.matchId) {
                          <tr>
                            <td class="ps-4">{{ match.matchNumber }}</td>
                            <td>{{ match.matchId }}</td>
                            <td>{{ match.score }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + tournaments.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="tournaments.length < resultsPerPage">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="tournaments.length < resultsPerPage">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
